exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vertical-divider {\n  position: relative;\n  width: 31px;\n}\n\n.vertical-bar {\n  width: 3px;\n  margin-left: 14px;\n  height: 100%;\n  background-color: black;\n  z-index: 0;\n}\n\n.icon {\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/WikiCollapse/main.css
// module id = 779
// module chunks = 0